import React from 'react';
import { Lock } from 'lucide-react';

interface Props {
  onUpgradeClick: () => void;
}

export function SeriesLockedOverlay({ onUpgradeClick }: Props) {
  return (
    <div
      onClick={onUpgradeClick}
      className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 cursor-pointer
                 backdrop-blur-sm bg-black/40 rounded-xl transition-opacity"
    >
      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 border border-white/20">
        <Lock className="h-5 w-5 text-white" />
      </div>
      <span className="text-xs font-medium text-white/90 px-3 text-center">
        Series Access required
      </span>
    </div>
  );
}
